import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'
import { HeaderMain } from '../../Common/HeaderMain'
import { Footer } from '../../Common/Footer'
import { ComPhoto, GoodsPhoto } from '../../../js/ComponentManager'

import { Link } from 'react-router-dom';
/* 개발담당:양유빈
 * 화면기능:라이브 챗 리스트
 * 세부설명:
*/

export class LiveChatList extends Component {
    static displayName = LiveChatList.name;

    constructor(props) {
        super(props);
        this.Page_Size = Big3Common.WebConfig.Page_Size;
        this.state = {
            ChatList: []
        };
    }
    //초기화
    componentDidMount() {
        this.CallLiveChatListData();
    }
    //주문문의 조회
    async CallLiveChatListData() {
        try {

            Big3Common.Util.LoadingOn();
            
            let Data = await Big3Common.Post('api/Chat/LiveChat/GetChatmgtList', {});
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const CallList = JSON.parse(Data.dataTable);
                this.setState({ ChatList: CallList});
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallLiveChatListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    Listrender() {
        const ChatList = this.state.ChatList;
        return (
            <>
                {ChatList.map(list =>

                    <Link to={`/Chat/LiveChat/Index?uid=${list.uid}`} key={list.uid}>
                        <div className="alert_content_v2 alert_content" >
                            <div className="alert_img">
                                {
                                    list.photo === null ? 
                                        <GoodsPhoto className="alert_img_in" ImageSrc={list.img_100} />
                                    : 
                                        <ComPhoto className="alert_img_in" Photo={list.photo} />
                                }
                                
                            </div>
                            <div className="alert_txt">
                                <div className="shop_name">{list.whole_name}</div>
                                <div className="shop_address2">{list.bld_name} {list.flr_name}층 {list.whole_no_name}호</div>
                                <div className="alert_time">{list.reg_dt} {list.conf_count === 0 ? "" : <div className="alert_new"></div>}</div>
                            </div>
                        </div>
                    </Link>
                )}
            </>
        ) 
    }
    render() {
        let Listrender = this.Listrender();
        return (
            <>
                <HeaderMain
                    HeaderSub={{ Title: "채팅문의", LinkYn: "N", LinkUrl: "", ComponentUrl: "" }}
                    RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                />
                <div className="tap_box tap_box_v2">
                    <Link to="/Chat/ChatList/Index"><div className="n_tap"><div className="alert_tap">주문문의</div></div></Link>
                    <div className="n_tap">
                        <div className="alert_tap tap_on">
                            채팅문의
                            <sup>βeta</sup>
                        </div>
                    </div>
                </div>
                <div className="m_f_margin d_padding container_box">
                    {Listrender}
                </div>
                <Footer fillName="icon4" />
            </>
        );

    }

}
